// DO NOT EDIT -- generated from Go package fs/api/segment/solrq

///////////////
// Constants //
///////////////

export const DefinedEventField: string = "$definedevent";
